import { useEffect, useState } from 'react';
import { getLeaderboard } from '../services';
import { ILeaderboardItem, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

// Cache de módulo — leaderboard es una vista global pesada
const moduleCache: Map<string, { data: ILeaderboardItem[]; cachedAt: string; fetchedAt: number }> = new Map();
const STALE_MS = 15 * 60 * 1000;

export function useLeaderboard(options?: { team?: string }): HookState<ILeaderboardItem[]> {
	const [state, setState] = useState<HookState<ILeaderboardItem[]>>({
		data: null,
		loading: true,
		error: null,
		cachedAt: null,
	});

	const team = options?.team;

	useEffect(() => {
		let cancelled = false;
		const cacheKey = team ?? '__all__';
		const cached = moduleCache.get(cacheKey);

		if (cached && Date.now() - cached.fetchedAt < STALE_MS) {
			setState({ data: cached.data, loading: false, error: null, cachedAt: cached.cachedAt });
			return;
		}

		setState((prev) => ({ ...prev, loading: true, error: null }));

		getLeaderboard({ team })
			.then(({ data, cachedAt }) => {
				if (cancelled) return;
				moduleCache.set(cacheKey, { data, cachedAt: cachedAt ?? '', fetchedAt: Date.now() });
				setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled) setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
		};
	}, [team]);

	return state;
}
